<script lang="ts" setup>
import { useModal } from 'vue-final-modal'

import ShareLink from '~/components/modal-windows/ShareLink.vue'
import PartnerButton from '~/components/partner/PartnerButton.vue'
import constants from '~/constants'
import Page from '~/enums/page'

const props = defineProps<{
  bannerId: number
}>()

const emit = defineEmits<{
  (e: 'onButtonClick'): void
}>()

const imagePath = computed(() => `/images/pages/partner/b/${props.bannerId}.jpg`)

async function openShareLinkModalWindow (): Promise<void> {
  const link = `${constants.siteUrl}${Page.Partner}`

  await useModal({ component: ShareLink, attrs: { link } }).open()
}
</script>

<template>
  <section>
    <div class="container">
      <div class="relative flex h-auto flex-wrap items-stretch justify-center md:h-[360px] md:flex-nowrap">
        <div class="block-b-l">
          <div class="partner-b-left text-white">
            <div class="mb-4 flex justify-between">
              <h2 class="h1 mb-0">
                <template v-if="bannerId === 1">
                  Станьте партнёром iTAB и&nbsp;зарабатывайте вместе с&nbsp;нами!
                </template>
                <template v-else-if="bannerId === 2">
                  Для того, чтобы стать партнёром iTAB, просто нажмите кнопку ниже!
                </template>
              </h2>

              <div
                class="product-section__share-link-button flex cursor-pointer items-center justify-center bg-white"
                @click="openShareLinkModalWindow"
              >
                <SvgIcon name="outlined/ios-share" />
              </div>
            </div>

            <p class="leading-5 lg:text-[20px] lg:leading-6">
              <template v-if="bannerId === 1">
                iTAB&nbsp;— крупнейший маркетплейс добавок и&nbsp;товаров для здоровья на&nbsp;территории СНГ. Нам доверяет более 3500&nbsp;интегративных специалистов, ведь у наших продуктов <strong>активные формы, высокие дозировки и&nbsp;чистые составы</strong>.
              </template>
              <template v-else-if="bannerId === 2">
                В&nbsp;течение 2&nbsp;рабочих дней мы&nbsp;подтвердим ваш промокод и&nbsp;пришлём ссылку на&nbsp;закрытый телеграм-канал для партнёров. Станьте частью интегративного сообщества iTAB уже сегодня!
              </template>
            </p>

            <PartnerButton class="mt-4" :color-type="1" :text-type="1" @click="emit('onButtonClick')" />
          </div>
        </div>

        <div class="block-b-r">
          <div class="flex items-end">
            <img v-lazy="imagePath" alt="" loading="lazy">
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
@use 'sass:color';

@use 'assets/css/variables';

.block-b-l,
.block-b-r {
  @media (max-width: 768px) {
    width: 100% !important;
  }
}

.block-b-r {
  &::after {
    background-color: transparent;
    content: '';
    display: block;
    height: 100%;
    position: absolute;
    right: 0;
    top: 0;
    width: 10%;
  }

  &::before {
    background: variables.$itab-gradient-to-bottom;
    border-radius: 16px;
    content: '';
    display: block;
    height: 100%;
    left: 16px;
    position: absolute;
    top: 0;
    width: calc(100% - 32px);
    z-index: -1;

    @media (max-width: 768px) {
      display: none;
    }
  }
}

.partner-b-left {
  background: variables.$itab-gradient-to-bottom;
  border-bottom-left-radius: 16px;
  border-top-left-radius: 16px;
  box-sizing: border-box;
  flex-basis: 100%;
  height: 100%;
  padding: 24px;

  @media (max-width: 768px) {
    border-radius: 16px;
  }
}

img {
  border-radius: 16px;
  height: 360px;
  max-width: initial;

  @media (max-width: 768px) {
    height: auto;
    margin-top: 24px;
    width: 100%;
  }
}

.product-section__share-link-button {
  border-radius: 50%;
  color: variables.$main-green-color;
  font-size: 24px;
  height: 40px;
  margin-left: 24px;
  width: 40px;
  flex-shrink: 0;

  @media (max-width: 768px) {
    margin-left: 16px;
  }
}
</style>
